import React from "react";
import {
  iconNew,
  RotaButtonIcon,
  RotaNewModal,
  ModalHeader,
  RotaRatingStars
} from "@teamrota/rota-design";

import styled from "styled-components";

import RotaButtonNew, {
  Variant
} from "@teamrota/rota-design/dist/components/button";

const { Cancel } = iconNew;

const BlockModalContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const ModalTitle = styled.h3`
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  margin-bottom: 48px;

  & > span {
    font-weight: 700;
  }
`;

const ModalText = styled.h3`
  font-size: 20px;
  font-style: normal;
  font-weight: 500;
  line-height: 24px;
`;

const ButtonsWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  align-items: center;
  gap: 64px;
  padding: 0px 48px;
  margin-top: 48px;
`;

interface MemberBlockingModalProps {
  onClose: () => void;
  onCancel: () => void;
  onConfirm: () => void;
  rating: number;
}

export const MemberBlockingModal = ({
  onClose,
  onCancel,
  onConfirm,
  rating
}: MemberBlockingModalProps) => {
  return (
    <RotaNewModal
      size="small"
      onClose={onClose}
      header={
        <ModalHeader
          endAction={
            <RotaButtonIcon onClick={onClose}>
              <Cancel />
            </RotaButtonIcon>
          }
        />
      }
    >
      <BlockModalContent>
        <ModalTitle>You have rated this member</ModalTitle>
        <RotaRatingStars rating={rating} isDisabled />
        <ModalText>Would you also like to block this member?</ModalText>
        <ButtonsWrapper>
          <RotaButtonNew variant={Variant.outlined} onClick={onCancel}>
            No
          </RotaButtonNew>
          <RotaButtonNew onClick={onConfirm}>Yes</RotaButtonNew>
        </ButtonsWrapper>
      </BlockModalContent>
    </RotaNewModal>
  );
};
